module.exports = __webpack_public_path__ + "static/media/p6_img1.07eb3ef3.png";